/* eslint-disable camelcase */
/*
 * 企業側 ホットライン相談申し込み メッセージ
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_CLIENT_HOTLINE_REQUEST_MESSAGE = 'API_UPDATE_CLIENT_HOTLINE_REQUEST_MESSAGE';
export const API_UPDATE_CLIENT_HOTLINE_REQUEST_MESSAGE_LOG = 'API_UPDATE_CLIENT_HOTLINE_REQUEST_MESSAGE_LOG';
/**
 * クライアント：ホットライン相談申し込みメッセージ 更新
 */
export const apiUpdateClientHotlineRequestMessage = ({ json, path: { hotline_request_id, id } }, meta) => apiUpdate(API_UPDATE_CLIENT_HOTLINE_REQUEST_MESSAGE, `/client/hotline/${id}/request/${hotline_request_id}/message`, json, meta);
/**
 * クライアント：ホットライン相談申し込みメッセージログ 更新
 */
export const apiUpdateClientHotlineRequestMessageLog = ({ path: { hotline_request_id, hotline_request_message_id, id } }, meta) => apiUpdate(API_UPDATE_CLIENT_HOTLINE_REQUEST_MESSAGE_LOG, `/client/hotline/${id}/request/${hotline_request_id}/message_log/${hotline_request_message_id}`, {}, meta);
